import { useContext } from 'react'

import { Box, BoxProps, MediaQuery, rem, Stack } from '@mantine/core'

import useStyles from './index.styles'
import { FeatureCardContext } from '../../context'

export const VerticalCenterLayout = ({
  styles,
  classNames,
  ...rest
}: BoxProps) => {
  const { sectionName, icon, heading, content, viewAll } = useContext(
    FeatureCardContext,
  )
  const { classes } = useStyles(undefined, {
    name: 'FeatureCard__VerticalCenterLayout',
    styles,
    classNames,
  })
  return (
    <Stack className={classes.inner} {...rest}>
      <Stack className={classes.header}>
        {sectionName}
        {icon}
        {heading}
        {viewAll && (
          <MediaQuery smallerThan={'sm'} styles={{ display: 'none' }}>
            <Box>{viewAll}</Box>
          </MediaQuery>
        )}
      </Stack>
      {content}
      {viewAll && (
        <MediaQuery largerThan={'sm'} styles={{ display: 'none' }}>
          <Box
            className="viewall-bottom"
            sx={{
              padding: `0 ${rem(16)}  ${rem(16)}  ${rem(16)}`,
            }}
          >
            {viewAll}
          </Box>
        </MediaQuery>
      )}
    </Stack>
  )
}
